/**
 * One source of truth for launch pricing and the weekly promotion.
 * Every price, savings line and warranty message on the site reads from here.
 */

/**
 * While true, the Lifetime Replacement Warranty is included free.
 * Set to false ONLY when you decide to sell it as a $19.95 add-on.
 * Nothing on the site ever flips this automatically.
 */
export const LIFETIME_WARRANTY_PROMO_ACTIVE = true

export const WARRANTY_VALUE = 19.95

/** Official timezone and weekly deadline: Sunday 11:59:59 PM Eastern. */
export const PROMO_TIMEZONE = 'America/New_York'

/**
 * The sale's name, shown everywhere the offer is labeled. Change it here only
 * (e.g. 'Black Friday Sale' after November 11) and the whole site follows.
 */
export const SALE_NAME = 'Veterans Day Sale'
export const SALE_SHORT = 'Veterans Day'
export const SALE_TAGLINE = 'Honoring the men and women who served. 60% off for everyone who keeps America running.'

export const PRODUCT_NAME = 'GritVue X1™ Illuminated Work Glasses + Complete Care & Anti-Fog System'

export const pricing = {
  regular: 124.95,
  launch: 49.95,
  save: 75,
  discountPct: 60,
  separateValue: 166.6,
}

export const warrantyCopy = LIFETIME_WARRANTY_PROMO_ACTIVE
  ? {
      title: 'Lifetime Replacement Warranty',
      tagline: 'Break it. We replace it.',
      value: '$19.95 value',
      status: 'Included free with every multi-pack',
    }
  : {
      title: 'Lifetime Replacement Warranty',
      tagline: 'Break it. We replace it.',
      value: '$19.95',
      status: 'Optional add-on at checkout',
    }
